// extracted by mini-css-extract-plugin
export default {"wrap":"BlockedUnsafeMedia_wrap__niCRx","title":"BlockedUnsafeMedia_title__EIEpD","sub":"BlockedUnsafeMedia_sub__pf4sF","name":"BlockedUnsafeMedia_name__dqi+y"};